"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SaleMethodKeys = void 0;
var SaleMethodKeys = exports.SaleMethodKeys = ['PRIVATE_TREATY', 'EXPRESSION_OF_INTEREST', 'AUCTION', 'TENDER'];
var SaleMethodValues = {
  PRIVATE_TREATY: {
    name: 'PRIVATE_TREATY',
    label: 'Private Treaty',
    digitalDataKey: 'Private Treaty',
    urlSlug: 'sale',
    searchAliases: ['SALE']
  },
  EXPRESSION_OF_INTEREST: {
    name: 'EXPRESSION_OF_INTEREST',
    label: 'Expression of interest',
    digitalDataKey: 'Expression of Interest',
    urlSlug: 'eoi'
  },
  AUCTION: {
    name: 'AUCTION',
    label: 'Auctions',
    digitalDataKey: 'Auction',
    urlSlug: 'auctions'
  },
  TENDER: {
    name: 'TENDER',
    label: 'Tenders',
    digitalDataKey: 'Tender',
    urlSlug: 'tenders'
  }
};
var SaleMethod = SaleMethodValues;
var _default = exports.default = SaleMethod;